// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__19m3d","head":"Table_head__38kxy","col":"Table_col__3bfjf"};